import { mapPreviewUrl } from "@dailywars/core/engine/maps/mapId";
import type { CSSProperties, ReactNode } from "react";

import { cn } from "#/lib/utils";

export function MapPreviewImage({
  mapId,
  maxSize,
  fillWidth = false,
  className,
  children,
}: {
  mapId: string;
  maxSize: number;
  fillWidth?: boolean;
  className?: string;
  children?: ReactNode;
}) {
  const maxBounds = { maxWidth: maxSize, maxHeight: maxSize };
  const previewMaxStyle = {
    maxWidth: maxSize,
    "--preview-max": `${maxSize}px`,
  } as CSSProperties;

  if (fillWidth) {
    return (
      <div
        className="@container/preview mx-auto aspect-square w-full min-h-0 min-w-0 overflow-hidden"
        style={previewMaxStyle}
      >
        <div className="grid size-full place-items-center">
          <div className={cn("relative grid", className)}>
            <img
              src={mapPreviewUrl(mapId)}
              alt=""
              className="col-start-1 row-start-1 block h-auto w-auto max-h-[min(100cqmin,var(--preview-max))] max-w-[min(100cqmin,var(--preview-max))]"
            />
            {children}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="flex shrink-0 items-center justify-center"
      style={{ width: maxSize, height: maxSize }}
    >
      <div className={cn("relative w-fit overflow-hidden", className)}>
        <img src={mapPreviewUrl(mapId)} alt="" className="block h-auto w-auto" style={maxBounds} />
        {children}
      </div>
    </div>
  );
}
